import { Box, styledComponent, TextField, Typography } from '@hermes/web-components'

export const StartSearchButton = styledComponent(Box)({
  backgroundClip: 'padding-box, border-box',
  backgroundOrigin: 'border-box',
  backgroundImage: 'linear-gradient(0deg, #fff, #fff), linear-gradient(90.9deg, #0040FF 0.26%, #B8CAFF 100%)',
  border: '1px solid transparent',
  borderRadius: '40px',
  padding: '13px 20px',
  gap: '10px',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0px 0px 107px 0px rgba(21, 21, 183, 0.30)'
})

export const StartSearchText = styledComponent(Typography)({
  background:
    'linear-gradient(90deg, rgba(17, 41, 113, 0.50) 0%, rgba(43, 89, 224, 0.50) 99.99%, rgba(43, 89, 224, 0.50) 100%), #2B59E0',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 500,
  margin: '0 auto',
  fontSize: '15px',
  lineHeight: '20px'
})

export const MobileSearchTextField = styledComponent(TextField, {
  shouldForwardProp: (prop: string) => !['isFilled', 'isError', 'isFocused'].includes(prop)
})<{ isFocused?: boolean; isFilled?: boolean; isError?: boolean }>(({ theme, isFocused, isFilled, isError }) => ({
  height: '48px',
  borderRadius: '24px',
  background: isFilled || isFocused ? '#fff' : '#F4F7FD',

  ...(isError && { '& fieldset': { borderColor: '#FF635C' } }),

  '& .MuiInputBase-root': {
    borderRadius: '24px',
    height: '100%',
    'input::placeholder': {
      ...theme.typography.body1,
      color: '#4C5870'
    },

    [theme.breakpoints.down('lg')]: {
      borderRadius: isFocused ? '16px 16px 0 0' : '24px'
    }
  },

  [theme.breakpoints.down('lg')]: {
    borderRadius: isFocused ? '16px 16px 0 0' : '24px'
  }
}))
